import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Button, Input, Select, AsyncSelect } from '../../ui';
import Continue from '../../Common/Continue';
import iconUser from '../../../assets/icons/icon-user.svg';
import iconNumber from '../../../assets/icons/icon-number.svg';
import Form from './Form.styles';
import Checkbox from './Checkbox';
import { validateEmail, mapSelectList, justNumbers } from '../../../helpers';
import { setClientValue, setRentalValue } from '../../../actions';
import { options } from '../../../operations';
import { getStreetsAsync } from '../../../operations/options';

function LaborData(props) {
  const {
    applicants,

    onValueChange,
    onRentalValueChange,

    getDepartments,
    onDepartmentChange,
    onCityChange,
    onStreetChange,

    addressState,
    addressCity,
    addressStreet,
    addressNumber,

    departments,
    cities,
    streets,

    showError
  } = props;

  useEffect(() => {
    getDepartments();
  }, [getDepartments]);

  const [validated, setValidated] = useState(false);

  useEffect(() => {
    const validatedCondition = () => {
      const {
        applicants
      } = props;

      function validateApplicant(applicant) {
        const {
          companyName,
          companyRUT,
          occupation,
          jobNetPay
        } = applicant;

        if (occupation && (occupation.value === 'empresas' || occupation.value === 'microempresas')) {
          return (
            companyName != '' &&
            companyRUT != '' &&
            occupation != null &&
            jobNetPay != '' &&
            justNumbers(jobNetPay)
          )
        } else {
          return (
            occupation != null &&
            jobNetPay != '' &&
            justNumbers(jobNetPay)
          );
        }
      }

      for (let i = 0; i < applicants.length; i++) {
        const applicant = applicants[i];

        if (!validateApplicant(applicant)) {
          return false;
        }
      }

      return true;
    }

    setValidated(validatedCondition());
  }, [props]);

  const onChangeApplicantValue = (index, type, value) => {
    const data = [...applicants];
    data[index][type] = value;
    onRentalValueChange('applicants', data);
  }

  const onChangeWorkApplicantAddress = (index, name, value) => {
    switch (name) {
      case 'addressState':
        onDepartmentChange(value);
        break;
      case 'addressCity':
        onCityChange(value);
        break;
      case 'addressStreet':
        onStreetChange(value);
        break;

      default:
        break;
    }

    onChangeApplicantValue(index, name, value);
  }

  const getCompanyBlock = (index) => (
    <React.Fragment key="company-block">
      <div className="Form-blockTitle">Datos de empresa</div>

      <div className="Form-row">
        <div className="Form-col">
          <Input
            id={"companyName-" + index}
            name={"companyName-" + index}
            placeholder="Nombre de empresa o razón social (*)"
            maxLength="50"
            type="text"
            leftIcon={iconUser}
            autoComplete="nope"
            onChange={event => onChangeApplicantValue(index, 'companyName', event.target.value)}
            value={applicants[index].companyName}
          />
        </div>

        <div className="Form-col">
          <Input
            id={"companyRUT-" + index}
            name={"companyRUT-" + index}
            placeholder="RUT de empresa (*)"
            maxLength="50"
            type="tel"
            leftIcon={iconUser}
            autoComplete="nope"
            onChange={event => justNumbers(event.target.value) && onChangeApplicantValue(index, 'companyRUT', event.target.value)}
            value={applicants[index].companyRUT}
          />
        </div>
      </div>
    </React.Fragment>
  );

  const getIncomeBlock = (index) => (
    <React.Fragment key="income-block">
      <div className="Form-col">
        <div className="Form-group">
          <Input
            id={`jobNetPay-${index}`}
            name={`jobNetPay-${index}`}
            placeholder="Ingreso neto mensual (*)"
            maxLength="50"
            type="tel"
            leftIcon={iconUser}
            autoComplete="nope"
            onChange={event => justNumbers(event.target.value) && onChangeApplicantValue(index, 'jobNetPay', event.target.value)}
            value={applicants[index].jobNetPay}
          />
        </div>

        <div
          className="Form-group"
          style={{ display: 'flex', justifyContent: 'space-around' }}
        >
          <Checkbox
            id={`jobNetPayCurrencyPeso-${index}`}
            name={`jobNetPayCurrency-${index}`}
            onChange={() => {
              onChangeApplicantValue(index, 'jobNetPayCurrency', false);
            }}
            checked={!applicants[index].jobNetPayCurrency}
            label="Pesos"
          />

          <Checkbox
            id={`jobNetPayCurrencyDolar-${index}`}
            name={`jobNetPayCurrency-${index}`}
            onChange={() => {
              onChangeApplicantValue(index, 'jobNetPayCurrency', true);
            }}
            checked={applicants[index].jobNetPayCurrency}
            label="Dólares"
          />
        </div>
      </div>
    </React.Fragment>
  );

  const getWorkActivityBlock = (index) => (
    <React.Fragment key="work-activity-block">
      <div className="Form-blockTitle">Actividad laboral</div>

      <div className="Form-row">
        <div className="Form-col">
          <div className="Form-group">
            <Input
              id={"jobTitle-" + index}
              name={"jobTitle-" + index}
              placeholder="Puesto / Cargo"
              maxLength="50"
              type="text"
              leftIcon={iconUser}
              autoComplete="nope"
              onChange={event =>
                onChangeApplicantValue(index, 'jobTitle', event.target.value)
              }
              value={applicants[index].jobTitle}
            />
          </div>

          <div className="Form-group">
            <Input
              id={"jobYears-" + index}
              name={"jobYears-" + index}
              placeholder="Antigüedad (años)"
              maxLength="50"
              type="tel"
              leftIcon={iconUser}
              autoComplete="nope"
              onChange={event => justNumbers(event.target.value) && onChangeApplicantValue(index, 'jobYears', event.target.value)}
              value={applicants[index].jobYears}
            />
          </div>
        </div>

        {getIncomeBlock(index)}
      </div>
    </React.Fragment>
  );

  const getWorkAddressBlock = (index) => (
    <React.Fragment key="word-address-block">
      <div className="Form-blockTitle">Domicilio laboral</div>
      <div className="Form-row">
        <div className="Form-col">
          <div className="Form-group">
            <Select
              id={"workAddressState-" + index}
              leftIcon={iconNumber}
              name={"workAddressState-" + index}
              value={applicants[index].workAddressState}
              onChange={value => {
                onChangeWorkApplicantAddress(index, 'workAddressState', value);
              }}
              placeholder="Seleccione un departamento"
              options={mapSelectList(departments)}
            />
          </div>

          <div className="Form-group">
            <Select
              id={"workAddressCity-" + index}
              leftIcon={iconNumber}
              name={"workAddressCity-" + index}
              value={applicants[index].workAddressCity}
              onChange={value => {
                onChangeWorkApplicantAddress(index, 'workAddressCity', value);
              }}
              placeholder="Seleccione una ciudad"
              options={mapSelectList(cities)}
              noOptionsMessage={() =>
                'Sin ciudades. Seleccione el Departamento primero.'
              }
              loadingMessage={() => 'Cargando...'}
            />
          </div>
        </div>

        <div className="Form-col">
          <div className="Form-group">
            <AsyncSelect
              id={"workAddressStreet-" + index}
              leftIcon={iconUser}
              name={"workAddressStreet-" + index}
              value={applicants[index].workAddressStreet}
              onChange={(value) => onChangeWorkApplicantAddress(index, 'workAddressStreet', value)}
              placeholder="Seleccione una calle"
              loadOptions={(inputValue) => getStreetsAsync(addressState, addressCity, inputValue)}
              // cacheOptions
              showAlert={applicants[index].workAddressStreet === ''}
              disabled={applicants[index].workAddressCity === null}
              noOptionsMessage={() =>
                'Sin calles. Seleccione el Departamento y la Ciudad primero, y comience a escribir el nombre'
              }
              loadingMessage={() => 'Cargando...'}
            />
          </div>

          <div className="Form-group">
            <Input
              id={"workAddressNumber-" + index}
              name={"workAddressNumber-" + index}
              placeholder="Nro. de puerta, manzana, solar"
              maxLength="50"
              type="text"
              value={applicants[index].workAddressNumber}
              onChange={event => {
                onChangeApplicantValue(index, 'workAddressNumber', event.target.value);
              }}
              leftIcon={iconNumber}
              showAlert={showError && !applicants[index].workAddressNumber}
              autoComplete="nope"
            />
          </div>

          <div className="Form-group">
            <Input
              id={"workAddressApto-" + index}
              name={"workAddressApto-" + index}
              placeholder="Nro. de apto"
              maxLength="10"
              type="text"
              value={applicants[index].workAddressApto}
              onChange={(event) => { onChangeApplicantValue(index, 'workAddressApto', event.target.value) }}
              leftIcon={iconNumber}
              // showAlert={showError && !workAddressApto}
              autoComplete="nope"
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );

  const getWorkForm = (index, occupation) => {
    let Form = null;

    switch (occupation) {
      case 'empleado':
        Form = [getWorkActivityBlock(index), getWorkAddressBlock(index)];
        break;

      case 'independiente':
      case 'renta_alquiler':
      case 'renta_pension':
        Form = getWorkActivityBlock(index);
        break;

      case 'jubilado':
        Form = <div className="Form-row">{getIncomeBlock(index)}</div>;
        break;

      case 'empresas':
      case 'microempresas':
        Form = [
          getCompanyBlock(index),
          getWorkActivityBlock(index),
          getWorkAddressBlock(index)
        ];
        break;

      default:
        break;
    }

    return Form;
  };

  return (
    <Form>
      <div className="Form-title">Datos laborales</div>

      {applicants.map((applicant, index) => {
        return (
          <div key={index}>
            <h3 style={{ fontSize: 18, marginBottom: 10 }}>
              {index === 0 ? 'Solicitante' : `Co-solicitante ${index}`}
            </h3>

            <div className="Form-row">
              <div className="Form-col">
                <div className="Form-group">
                  <Select
                    id={"occupation-" + index}
                    name={"occupation-" + index}
                    placeholder="Situación laboral (*)"
                    options={[
                      { value: 'empleado', label: 'Empleado' },
                      {
                        value: 'independiente',
                        label: 'Profesionales o trabajadores independientes'
                      },
                      { value: 'jubilado', label: 'Jubilado' },
                      { value: 'renta_alquiler', label: 'Renta de alquiler' },
                      { value: 'renta_pension', label: 'Renta de pensión' },
                      { value: 'empresas', label: 'Empresas' },
                      {
                        value: 'microempresas',
                        label: 'Microempresas (S.A. y S.R.L.)'
                      }
                    ]}
                    label="Situación laboral"
                    leftIcon={iconUser}
                    value={applicants[index].occupation}
                    onChange={value => onChangeApplicantValue(index, 'occupation', value)}
                  />
                </div>
              </div>
            </div>

            {applicants[index].occupation && getWorkForm(index, applicants[index].occupation.value)}
          </div>
        )
      })}

      <Continue state={validated} />
    </Form>
  );
}

const mapStateToProps = state => {
  return {
    applicants: state.rental.applicants,

    addressState: state.client.addressState,
    addressCity: state.client.addressCity,
    addressStreet: state.client.addressStreet,
    addressNumber: state.client.addressNumber,
    // addressApto: state.client.addressApto,

    departments: state.options.departments,
    cities: state.options.cities,
    streets: state.options.streets,

    showError: state.steps.showError
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getDepartments: () => {
      dispatch(options.getDepartments());
    },
    onValueChange: (type, value) => {
      dispatch(setRentalValue(type, value));
    },
    onRentalValueChange: (type, value) => {
      dispatch(setRentalValue(type, value));
    },
    onDepartmentChange: addressState => {
      dispatch(options.setDepartment(addressState));
    },
    onCityChange: addressCity => {
      dispatch(options.setCity(addressCity));
    },
    onStreetChange: addressStreet => {
      dispatch(setClientValue('addressStreet', addressStreet));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LaborData);
